export type ToastVariant = 'success' | 'error' | 'info' | 'warning';

export interface ToastOptions {
  title?: string;
  message: string;
  variant?: ToastVariant;
  duration?: number;
}

export interface ConfirmDialogOptions {
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'default' | 'danger';
}

export const showToast = (options: ToastOptions | string) => {
  const detail =
    typeof options === 'string'
      ? { message: options, variant: 'info' as ToastVariant }
      : options;

  window.dispatchEvent(new CustomEvent<ToastOptions>('app:toast', { detail }));
};

export const showErrorToast = (message: unknown, title = 'Something went wrong') => {
  showToast({
    title,
    message: message instanceof Error ? message.message : String(message),
    variant: 'error',
  });
};

export const confirmDialog = (options: ConfirmDialogOptions | string) =>
  new Promise<boolean>((resolve) => {
    const detail =
      typeof options === 'string'
        ? { message: options, resolve }
        : { ...options, resolve };

    window.dispatchEvent(new CustomEvent('app:confirm', { detail }));
  });
